import {DetailCargo} from "~/apps/packages/cargos/queries";
import {Card, CardContent, Grid, Paper, Typography} from "@mui/material";
import React, {Fragment} from "react";
import moment from "moment";
import {Box} from "@mui/system";
import {formatDate} from "~/apps/core/utils";
import {useTheme} from "@mui/styles";
import {PortTheme} from "~/ui/theme";


export type CargoDetailHistory = {
    cargo: Pick<DetailCargo, "operations">
}

const Item = ({children, header}: {children: any, header?: boolean}) => {
    const theme = useTheme<PortTheme>();
    return (
        <Box
            bgcolor={header ? theme.palette.additionalPrimaryDisabled.main : null}
            paddingY="10px" paddingX="10px" width="100%">
            {children}
        </Box>
    )
}

function renderText(text) {
    const lines = text.split("\n").filter(Boolean);
    return lines.map((line, index) => (
        <>
            {line}
            {index < lines.length - 1 && <br/>}
        </>
    ))
}

export const CargoDetailHistory = (props: CargoDetailHistory) => {
    const {cargo} = props;

    return (
        <Box paddingY={2}>
            <Card>
                <Grid container direction="column" wrap="nowrap">
                    {cargo.operations?.map((operation, index) => (
                        <Fragment key={index}>
                            {(index == 0 || !moment(operation.date).isSame(cargo.operations[index - 1]?.date, "day")) && (
                                <Grid item>
                                    <Item header={true}>
                                        <Typography color="white" variant="cardTitle2">
                                            {formatDate(moment(operation.date))}
                                        </Typography>
                                    </Item>
                                </Grid>
                            )}
                            <Grid item>
                                <Item>
                                    <Grid container spacing="8px" direction="row" wrap="nowrap" justifyContent="space-between">
                                        <Grid item>
                                            <Typography variant="inputText2" color="primary" display="block">
                                                {operation.type}
                                            </Typography>
                                            <Typography variant="inputTitle2" color="textSecondary" display="block">
                                                {renderText(operation.description)}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="inputText2" color="primary">
                                                {moment(operation.date).format("HH:mm")}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Item>
                            </Grid>
                        </Fragment>
                    ))}
                </Grid>
            </Card>
        </Box>
    )
}